import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  InputSignal,
  Signal,
} from '@angular/core';
import { AlfredSessionService } from './alfred-session.service';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faCommentExclamation,
  IconDefinition,
} from '@fortawesome/pro-regular-svg-icons';
import { Session } from '../../models/session.model';
import { User } from '../../models/user.model';

@Component({
  selector: 'lyceo-support-mailto-alfred',
  imports: [FaIconComponent],
  templateUrl: './support-mailto-alfred.component.html',
  styleUrls: ['./support-mailto-alfred.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SupportMailtoAlfredComponent {
  private readonly alfredSessionService: AlfredSessionService =
    inject(AlfredSessionService);

  public readonly questionAmount: InputSignal<number> =
    input.required<number>();
  public readonly questionPosition: InputSignal<number> =
    input.required<number>();

  public readonly mailToQueryParams: Signal<string> = computed(() => {
    const user: User | undefined = this.alfredSessionService.userData();
    const session: Session | undefined =
      this.alfredSessionService.sessionData();
    if (session) {
      let params: string = `subject=Mijn feedback over vraag ${this.questionPosition()} van ${session.questionnaire.title}`;
      params += `&body=`;
      params += `%0D%0A%0D%0A%0D%0A%0D%0A%0D%0A----%0D%0A%0D%0A`;
      if (user) {
        params += `${user.name} - ${user.emailAddress}%0D%0A`;
        params += `%0D%0A`;
      }
      params += `Vragenlijst-id: ${session.questionnaire.id}%0D%0A`;
      params += `Vraag: ${this.questionPosition()} van ${this.questionAmount()}%0D%0A`;

      return params;
    }

    return `subject=Mijn feedback over een vraag`;
  });

  protected readonly faCommentExclamation: IconDefinition =
    faCommentExclamation;
}
